import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// ฟอนต์ self-host เฉพาะ subset ไทยและละติน (ตัด subset อื่นเพื่อลดขนาด CSS ที่บล็อกการแสดงผล)
import "@fontsource/ibm-plex-sans-thai/thai-400.css";
import "@fontsource/ibm-plex-sans-thai/latin-400.css";
import "@fontsource/ibm-plex-sans-thai/thai-500.css";
import "@fontsource/ibm-plex-sans-thai/latin-500.css";
import "@fontsource/ibm-plex-sans-thai/thai-600.css";
import "@fontsource/ibm-plex-sans-thai/latin-600.css";
import "@fontsource/ibm-plex-sans-thai/thai-700.css";
import "@fontsource/ibm-plex-sans-thai/latin-700.css";
import "@fontsource/sarabun/thai-400.css";
import "@fontsource/sarabun/latin-400.css";
import "@fontsource/sarabun/thai-600.css";
import "@fontsource/sarabun/latin-600.css";
import "@fontsource/sarabun/thai-700.css";
import "@fontsource/sarabun/latin-700.css";
import "./index.css";
import "./styles/app.css";
import "./styles/pages.css";
import "./styles/extras.css";
import "./styles/flow.css";
import "./styles/jobs.css";
import "./styles/billing.css";
import "./styles/tailwind-utilities.css";
import { App } from "./App";
import { Providers } from "./providers";
import { registerPwa } from "./pwa";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>,
);

registerPwa();
